import React, { useState } from "react";
import Input from "../../components/Input";
import Button from "../../components/Button";
import { Link } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import '../pages.css'
import logoProdesp from '../../images/Logo Prodesp novo horizontal_cor.png'
import logoExpansao from '../../images/logo-padrao.png'
import loading from '../../images/loading.png'

const Signin = ()=>{
    const { signin } = useAuth();
    const [rotating,setRotating] = useState(false)
    const [cpf, setCpf] = useState("");
    const [senha, setSenha] = useState("");
    const [error, setError] = useState("");
    const [disabled,setDisabled] = useState(false)

    const handleLogin = async() => {
        if (!cpf | !senha) {
          setError("Preencha todos os campos");
          return;
        }
        setDisabled(true)
        setRotating(true)
        var res = await signin(cpf, senha);
        if(!res.success) {
          setDisabled(false)
          setRotating(false)
          setError(res.message)
        }
        else {
          window.location.replace(res.url);
        }
      };
    

    return (
        <div className="container_login">
          <div className="logo_prodesp">
            <img src={logoExpansao} alt="logo Prodesp"/>
          </div>
          <div className="titulo_login">Login externo - Moodle Expansão</div>
          <div className="content">
            <Input
              type="email"
              placeholder="Digite seu CPF"
              value={cpf}
              onChange={(e) => [setCpf(e.target.value), setError("")]}
            />
            <Input
              type="password"
              placeholder="Digite sua Senha"
              value={senha}
              onChange={(e) => [setSenha(e.target.value), setError("")]}
            />
            {error == '' ? null : <div className="errorDiv">{error}</div>}
            {!rotating ? null : <div className="spinning"><img src={loading} alt="spinning"/></div>}
            <Button Text="Entrar" onClick={handleLogin} Disabled={disabled}/>
            <div className="divSignUp">
              Não tem uma conta?
              <div className="div_link">
                <Link className="link_registre-se" to="/signup">&nbsp;Registre-se</Link>
              </div>
            </div>
            <div className="div_logo_expansao">
              <img src={logoProdesp} alt="logo Prodesp"/>
            </div>
          </div>
        </div>        
      );
}

export default Signin